app.service("CollectionProductService", ['$rootScope', function ($rootScope) {

    const modelConstructor = $rootScope.model_constructor;

    const RouteChoice = modelConstructor.RouteChoice;

    const CollectionProductModel = modelConstructor.extend(modelConstructor.RouteModel, {
        name: "Collection Product",
        id: "collection_product",
        navigation_pointer: "collection_product_id",
        stop_if_choice_route_empty: true,
        allow_single_choice_route: true,
        getProductModel: getProductModel,
        getProductMatrixModel: getProductMatrixModel
    });

    this.factory = new modelConstructor.RouteFactory({

        birth: function (values) {
            return new CollectionProductModel(values);
        },
        applyModelVariation: applyModelVariation
    })

    function applyModelVariation(model) {

        this.super(model);

        const variationIDs = model.variation_ids;
        const browseID = variationIDs.browse_id;
        const baseComponentID = variationIDs.base_component_id;
        const parentCategoryID = variationIDs.parent_category_id;

        let sourceModel;
        let nextModelID;
        if (baseComponentID !== "solution" || browseID === "solution") {
            sourceModel = model.getProductModel();
            nextModelID = "individual_product";
        } else {
            sourceModel = model.getProductMatrixModel();
            nextModelID = "solution";
        }
        if (!sourceModel) {
            return
        }
        const fromChoiceList = sourceModel.choiceList();
        const choiceOrder = []
        const choices = {}
        for (let i = 0; i < fromChoiceList.length; i++) {
            const fromChoice = fromChoiceList[i];
            if (parentCategoryID && (!fromChoice.parent_category_ids || !fromChoice.parent_category_ids.includes(parentCategoryID))) {
                continue;
            }
            const stateIDs = {
                product_id: fromChoice.id
            }
            if (fromChoice.solution_ids && fromChoice.solution_ids.length === 1) {
                stateIDs.solution_id = fromChoice.solution_ids[0];
            }
            if (fromChoice.door_type_id) {
                stateIDs.door_type_id = fromChoice.door_type_id;
            }
            if (fromChoice.assembly_ids && fromChoice.assembly_ids.length === 1) {
                stateIDs.assembly_id = fromChoice.assembly_ids[0];
            }
            const choice = new RouteChoice({
                id: fromChoice.id,
                name: fromChoice.name,
                state_ids: stateIDs
            });
            choiceOrder.push(choice.id);
            choices[choice.id] = choice;
        }
        model.choice_order = choiceOrder
        model.choices = choices
        model.next_model_id = nextModelID
    }

    function getProductModel() {
        const model = this.root;
        const variationIDs = model.variation_ids;
        switch (variationIDs.base_component_id) {
            case "solution":
                return $rootScope.factory.product_solution.getModel(variationIDs);
            case "stock":
                return $rootScope.factory.product_stock.getModel(variationIDs);
            case "cabinet_kitchen":
                return $rootScope.factory.product_cabinet_kitchen.getModel(variationIDs);
            case "cabinet_bedroom":
                return $rootScope.factory.product_cabinet_bedroom.getModel(variationIDs);
            case "hettich":
                return $rootScope.factory.product_hettich.getModel(variationIDs);
            default:
                return null;
        }
    }

    function getProductMatrixModel() {
        const model = this.root;
        const variationIDs = model.variation_ids;
        if (variationIDs.base_component_id === "solution") {
            return $rootScope.factory.matrix_product.getModel(variationIDs);
        }
        return null;
    }

}]);